// extracted by mini-css-extract-plugin
export default {"depoiments_section":"depoiments_section_depoiments_section__UTpIm","yt_container":"depoiments_section_yt_container__fejfS"};